import React from 'react';
import { I18n } from '@aws-amplify/core';
import { DatePickerWrapper } from './styles';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

export function FinalDateFormItem(): JSX.Element {
	return (
		<FormItemWrapper name="final_date" label={I18n.get('Final date')} labelCol={{ span: 24 }}>
			<DatePickerWrapper
				format="L"
				placeholder={I18n.get('Final date')}
				disabledDate={(currentDate) => currentDate && currentDate.valueOf() > Date.now()}
			/>
		</FormItemWrapper>
	);
}
